<template>
  <v-col cols="12" lg="4" md="4">
    <div :class="['sticky', rightColumnClass]">
      <SummaryCardContent>
        <slot v-if="canEditOffer" name="save-and-reset-offer-buttons"></slot>
        <slot v-if="canEditOffer && typeCOfferAllowed" name="change-type-button"></slot>
        <slot v-if="canEditOffer" name="change-discount-button"></slot>
        <slot name="signature-buttons"></slot>
        <slot v-if="canEditOffer" name="validations-button"></slot>
        <slot v-if="showUpdateOfferStatusButton" name="offer-status-button"></slot>
        <slot v-if="shouldDisplayExportButton" name="export-excel-button"></slot>
      </SummaryCardContent>
    </div>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM, GET_CONTRACT_MODEL } from '@/store/modules/offer/getters'
import SummaryCardContent from '@/components/summary-card/SummaryCardContent'
import { CONTRACT_MODEL, OFFER_TYPE } from '@/helpers/constants'

export default {
  name: 'SummaryCard',
  data() {
    return {
      rightColumnClass: this.$vuetify.breakpoint.lgAndUp ? 'd-flex justify-end' : 'mt-12',
    }
  },
  components: { SummaryCardContent },
  computed: {
    ...mapGetters('offer', [
      GET_OFFER_ITEM,
      'canEditOffer',
      'showUpdateOfferStatusButton',
      'typeCOfferAllowed',
    ]),
    ...mapGetters('offer', { contractModel: GET_CONTRACT_MODEL }),
    step() {
      return this[GET_OFFER_ITEM]('step')
    },
    offerType() {
      return this[GET_OFFER_ITEM]('type')
    },
    isPortugalContractModel() {
      return [
        CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT,
        CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT_NEXUS,
        CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026_PT_NEXUS,
      ].includes(this.contractModel)
    },
    isSpainContractModel() {
      return [
        CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025,
        CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026,
      ].includes(this.contractModel)
    },
    isBrokerOffer() {
      // Ofertas tipo B o C son ofertas Broker
      return this.offerType === OFFER_TYPE.B || this.offerType === OFFER_TYPE.C
    },
    shouldDisplayExportButton() {
      const isValidContractModel = this.isPortugalContractModel || this.isSpainContractModel
      
      if (!isValidContractModel) return false
      
      // Para ofertas tipo A: mostrar en paso 5 (Detalle de bultos)
      if (!this.isBrokerOffer) {
        return Math.floor(this.step) === 5
      }
      
      // Para ofertas tipo B/C (Broker): mostrar en paso 7 (Firma de contrato)
      return Math.floor(this.step) === 7
    },
  },
}
</script>

<style scoped lang="scss">
.sticky-box {
  button {
    flex: 0 1 auto;
  }
}
</style>
